import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* loadConfiguration3(action) {
  var payload = {
    action: "portal/loadConfiguration3",
  };
  yield put(serverRequest(payload));
}

export default loadConfiguration3;
